module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 10-24-43-076.a869ba63.mp4";